import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/front/10_cartoonish-4/10_cartoonish-4"
 * Contains 6 texture(s)
 */
export class CardsFront10Cartoonish4Atlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/front/10_cartoonish-4/10_cartoonish-4';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '7-spades.png',
        '7-hearts.png',
        '7-diamonds.png',
        '7-clubs.png',
        '6-spades.png',
        '6-hearts.png'
    ] as const;
}
